import * as React from 'react';
import Loader from './loader';
import { options } from './options';

interface Props {
  isVisible?: boolean;
}

const PageLoader: React.FC<Props> = props => {
  const { isVisible } = props;
  return (
    <div
      className="animHolder"
      style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translateX(-50%) translateY(-50%)',
        maxWidth: '90px',
      }}
    >
      <Loader isVisible={isVisible} animationData={options.loading1} />
    </div>
  );
};

PageLoader.defaultProps = {
  isVisible: true,
};

export default PageLoader;
try {
    // @ts-ignore
    pageLoader.displayName = "pageLoader";
    // @ts-ignore
    pageLoader.__docgenInfo = { "description": "", "displayName": "pageLoader", "props": { "isVisible": { "defaultValue": { value: true }, "description": "", "name": "isVisible", "required": false, "type": { "name": "boolean" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/loader/pageLoader.tsx#pageLoader"] = { docgenInfo: pageLoader.__docgenInfo, name: "pageLoader", path: "src/components/loader/pageLoader.tsx#pageLoader" };
}
catch (__react_docgen_typescript_loader_error) { }